import { useTranslation } from "react-i18next";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { Label } from "@/shared/components/ui/label";
import { Switch } from "@/shared/components/ui/switch";
import { useToast } from "@/shared/components/ui/use-toast";
import { resolveApiErrorMessage } from "@/shared/utils/apiErrorMessage";
import { LearningsService } from "../services/learningsService";

/**
 * "Não revisar minhas conversas" (AB#87286), nas preferências do perfil. Vale para a
 * organização ativa: a revisão para de ler as conversas da pessoa a partir dali.
 */
export const LearningsOptOutSetting = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const queryKey = ["learnings-opt-out"];
  const { data, isLoading } = useQuery({ queryKey, queryFn: () => LearningsService.mySettings() });

  const change = async (optOut: boolean) => {
    queryClient.setQueryData(queryKey, { opt_out: optOut });
    try {
      queryClient.setQueryData(queryKey, await LearningsService.saveMySettings(optOut));
    } catch (error) {
      queryClient.setQueryData(queryKey, { opt_out: !optOut });
      toast({
        title: t("learnings.optOut.saveError"),
        description: resolveApiErrorMessage(error, t),
        variant: "destructive",
      });
    }
  };

  return (
    <div className="flex items-start justify-between gap-4 border-t border-border/40 pt-4">
      <div className="flex-1">
        <Label htmlFor="learnings-opt-out" className="text-sm font-medium">
          {t("learnings.optOut.label")}
        </Label>
        <p className="mt-1 text-xs text-muted-foreground">{t("learnings.optOut.hint")}</p>
      </div>
      <Switch
        id="learnings-opt-out"
        checked={!!data?.opt_out}
        onCheckedChange={(next) => void change(next)}
        disabled={isLoading}
      />
    </div>
  );
};
